import { Component } from '@angular/core';
// components
import { AboutSectionComponent } from './components/about-section/about-section.component';
import { FaqSectionComponent } from '@core/components/faq-section/faq-section.component';
// mock data
import { contactFAQ } from '@app/+about/shared/mock/contact-page';
// types
import { AccordionData } from '@app/shared/types/accordion-data.type';

@Component({
  selector: 'pwj-about',
  standalone: true,
  imports: [AboutSectionComponent, FaqSectionComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
})
export class AboutComponent {
  public faqData: AccordionData[] = contactFAQ;
}
